import React from 'react'
import { Route, Switch } from 'react-router'

import Home from '../components/pages/Home'
import NoMatch from '../components/pages/NoMatch'
import AdminNavBar from '../components/partials/AdminNavBar'
import NavBar from '../components/partials/NavBar'
import Login from '../components/pages/admin/Login'
import UsersList from '../components/pages/admin/UsersList'
import LocationsList from '../components/pages/admin/LocationsList'
import UsersMap from '../components/pages/admin/UsersMap'
import Privacy from '../components/pages/Privacy'
import DrawingsMap from '../components/pages/admin/DrawingsMap'
import FeedMap from '../components/pages/admin/FeedMap'
import MessagesList from '../components/pages/admin/MessagesList'
import RecentSessionsMap from '../components/pages/admin/RecentSessionsMap'
import CountriesList from '../components/pages/admin/CountriesList'

import Map from '../components/pages/Map';
import NightMap from '../components/pages/NightMap';
import Dashboard from '../components/pages/Dashboard/v3';
import DashboardV1 from '../components/pages/Dashboard/v1/Dashboard';
import EditDrawing from '../components/pages/Edit';

import Hello from '../components/pages/Hello';

// <Route path="/admin/drawing-session/:key" component={DrawingSessionDetails} />
export default (props) => {

  const { pathname } = props.history.location;

  return (
  <div>
    { pathname.includes("admin") ? <AdminNavBar pathname={pathname} /> : <NavBar /> }
    <Switch>

      <Route path="/admin/users/list" component={UsersList} />
      <Route path="/admin/users/map" component={UsersMap} />
      <Route path="/admin/map" component={DrawingsMap} />
      <Route path="/admin/messages/list" component={MessagesList} />
      <Route path="/admin/drawings/map" component={DrawingsMap} />
      <Route path="/admin/login" component={Login} />
      <Route path="/admin/recent/map" component={RecentSessionsMap} />
      <Route path="/admin/locations/list" component={LocationsList} />
      <Route path="/admin/countries/list" component={CountriesList} />
      <Route path="/admin/feed/map" component={FeedMap} />
      <Route path="/map/night" component={NightMap} />
      <Route path="/map" component={Map} />
      <Route path="/dashboard/v1" component={DashboardV1} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/edit/:key" component={EditDrawing} />
      <Route path="/hello/:key" component={Hello} />

      <Route exact path="/" component={Home} />
      <Route path="/privacy" component={Privacy} />

      <Route component={NoMatch} />
    </Switch>
  </div>
)
}



// WEBPACK FOOTER //
// ./src/routes/index.js